import { render, staticRenderFns } from "./AnredenCreate.vue?vue&type=template&id=11ddc125&scoped=true"
import script from "./AnredenCreate.vue?vue&type=script&lang=js"
export * from "./AnredenCreate.vue?vue&type=script&lang=js"
import style0 from "./AnredenCreate.vue?vue&type=style&index=0&id=11ddc125&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ddc125",
  null
  
)

export default component.exports